import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Support extends Component {
  static propTypes = {
    communities: PropTypes.array.isRequired,
  };

  state = {
    showContactForm: false,
    selectedCommunityIndex: 0,
  };

  contactStaff = () => {
    this.setState({ showContactForm: 'staff' });
  };

  contactUnion = () => {
    this.setState({ showContactForm: 'union' });
  };

  handleCommunitySelect = e => {
    this.setState({ selectedCommunityIndex: e.target.selectedIndex });
  };

  renderHeader = () => {
    const { showContactForm } = this.state;

    return (
      <div className="u-flex u-panel u-text-center u-cursor-pointer u-text-blue u-select-none u-overflow-hidden u-p-0 u-mb-0">
        <div
          className={`u-p-4 u-flex-1 u-border-r u-border-grey-lighter ${
            showContactForm === 'staff' ? 'u-bg-blue-lightest' : 'hover:u-bg-grey-lightest'
          }`}
          onClick={this.contactStaff}>
          <div className="u-text-l u-mb-1 u-font-bold">Contact your community manager</div>
          <div
            className="u-text-grey-dark u-mb-1 u-leading-tight u-mx-auto"
            style={{ maxWidth: '14rem' }}>
            For questions about events, mentors, and issues related to your community
          </div>
        </div>

        <div
          className={`u-p-4 u-flex-1 ${
            showContactForm === 'union' ? 'u-bg-blue-lightest' : 'hover:u-bg-grey-lightest'
          }`}
          onClick={this.contactUnion}>
          <div className="u-text-l u-mb-1 u-font-bold">Contact the Union team</div>
          <div
            className="u-text-grey-dark u-mb-1 u-leading-tight u-mx-auto"
            style={{ maxWidth: '14rem' }}>
            For feature requests, bugs, and other product-related issues
          </div>
        </div>
      </div>
    );
  };

  renderStaffContactForm = () => {
    const { communities } = this.props;
    const { selectedCommunityIndex } = this.state;

    return (
      <div className="u-panel u-clearfix">
        {communities.length > 1 ? (
          <div>
            <label htmlFor="community_id">Community</label>
            <select id="community_id" name="community_id" onChange={this.handleCommunitySelect}>
              {communities.map(community => (
                <option key={community.id} value={community.id}>
                  {community.name}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <input type="hidden" value={communities[0].id} name="community_id" />
        )}

        <label htmlFor="message">
          Your message to {communities[selectedCommunityIndex].name} staff
        </label>
        <textarea id="message" name="message" rows="15" />
        <button className="u-btn u-btn-primary u-float-right">Send</button>
      </div>
    );
  };

  renderUnionContactForm = () => (
    <div className="u-panel u-clearfix">
      <label htmlFor="message">Your message to Union</label>
      <textarea id="message" name="message" rows="15" />
      <button className="u-btn u-btn-primary u-float-right">Send</button>
    </div>
  );

  render() {
    const { showContactForm } = this.state;

    return (
      <div>
        {this.renderHeader()}
        {showContactForm === 'staff' && this.renderStaffContactForm()}
        {showContactForm === 'union' && this.renderUnionContactForm()}
      </div>
    );
  }
}
